import styles from "./Menu.module.scss";
import Layout from "../../Components/Layout/Layout";
import { Col, Row } from "antd";
import { Link } from "react-router-dom";
import BreadCrumb from "../../Components/BreadCrumb/BreadCrumb";

const Menu = () => {
    const menu_items = [
        {
            img: "/icon/menu/menu_1.svg",
            label: "My Orders",
            link: "/customer/orders",
        },
        {
            img: "/icon/menu/menu_2.svg",
            label: "Track Orders",
            link: "/track-order",
        },
        {
            img: "/icon/menu/menu_3.svg",
            label: "Recipes",
            link: "/",
        },
        {
            img: "/icon/menu/menu_4.svg",
            label: "Messages",
            link: "/",
        },
        {
            img: "/icon/menu/menu_5.svg",
            label: "Coupons",
            link: "/customer/coupons",
        },
        {
            img: "/icon/menu/menu_6.svg",
            label: "Desi Family",
            link: "/desi-family",
        },
        {
            img: "/icon/menu/menu_7.svg",
            label: "Returns",
            link: "/customer/return-refunds",
        },
        {
            img: "/icon/menu/menu_8.svg",
            label: "Payment",
            link: "/",
        },
        {
            img: "/icon/menu/menu_9.svg",
            label: "Settings",
            link: "/customer/account",
        },
        {
            img: "/icon/menu/menu_10.svg",
            label: "Service",
            link: "/",
        },
        {
            img: "/icon/menu/menu_11.svg",
            label: "Invite a friend",
            link: "/",
        },
        {
            img: "/icon/menu/menu_12.svg",
            label: `FAQ's`,
            link: "/faq",
        },
    ].filter((item) => item.link !== "/");
    return (
        <Layout>
            <div className={styles.wrapper}>
                <BreadCrumb
                    list={[
                        {
                            link: "/",
                            name: "Home",
                        },
                        {
                            link: "/menu",
                            name: "Menu",
                        },
                    ]}
                />
                <Row gutter={[15, 15]} style={{ marginTop: "2rem" }}>
                    {menu_items.map((item, index) => {
                        return (
                            <Col xs={8} key={index}>
                                <Link to={item.link}>
                                    <div className={styles.card}>
                                        <img src={item.img} alt="" />
                                        <span>{item.label}</span>
                                    </div>
                                </Link>
                            </Col>
                        );
                    })}
                </Row>
            </div>
        </Layout>
    );
};

export default Menu;
